// src/api/axios.js
import axios from 'axios';

// Get the base URL from environment or use default
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://copytrade.wiidin.tech/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  withCredentials: false
});

// Request interceptor to add token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log(`📤 ${config.method.toUpperCase()} ${config.baseURL}${config.url}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    console.log(`📥 ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    // Handle 403 Forbidden - Email not verified
    if (error.response && error.response.status === 403) {
      const data = error.response.data;
      if (data?.data?.requiresVerification) {
        localStorage.setItem('verificationEmail', data.data.email);
        // Redirect to verification required page
        if (window.location.pathname !== '/verify-required' && window.location.pathname !== '/verify-email') {
          window.location.href = '/verify-required';
        }
        return Promise.reject({
          ...error,
          requiresVerification: true,
          message: data.message || 'Please verify your email address.'
        });
      }
    }
    
    // Handle 401 Unauthorized - token expired or invalid
    if (error.response && error.response.status === 401) {
      // Clear auth data
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('user');
      
      // Redirect to login if not already there
      if (window.location.pathname !== '/login' && 
          window.location.pathname !== '/signup' &&
          window.location.pathname !== '/verify-email' &&
          window.location.pathname !== '/verify-required') {
        window.location.href = '/login';
      }
    }
    
    // Handle 409 Conflict - User already exists
    if (error.response && error.response.status === 409) {
      console.error('Conflict error:', error.response.data);
    }
    
    // Handle 500 Server Error
    if (error.response && error.response.status === 500) {
      console.error('Server error:', error.response.data);
    }
    
    console.error(`❌ ${error.config?.method?.toUpperCase() || 'UNKNOWN'} ${error.config?.url || 'UNKNOWN'} - ${error.response?.status || 'Network Error'}`);
    return Promise.reject(error);
  }
);

export default api;